import actions from '~/store/modules/shared/flash/actions'
import getters from '~/store/modules/shared/flash/getters'
import mutations from '~/store/modules/shared/flash/mutations'
import state from '~/store/modules/shared/flash/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
